// test2378
(2378 && 0);
